'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
}; // PROP RECEIVERS

var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.radio.input,
      size = _theme$reactackle$com.size,
      similarItemsSpacing = _theme$reactackle$com.similarItemsSpacing;
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n    \n    & + & {\n      margin-top: ' + (0, _reactackleCore.getValueString)(similarItemsSpacing) + ';\n    }\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var RadioStyled = exports.RadioStyled = _styledComponents2.default.div.withConfig({
  displayName: 'RadioStyled'
})(['user-select:none;', ' input[type=\'radio\']{', ';}'], baseProps, _reactackleCore.elementInvisible);

RadioStyled.propTypes = propTypes;
RadioStyled.displayName = 'RadioStyled';